import { makeStyles, Theme } from '@material-ui/core';
import { monochrome } from '../../theme/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  footnote: {
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.palette.text.secondary,
  },
  addFieldButton: {
    cursor: 'pointer',
  },

  customInput: {
    width: '100%',
    '& label + .MuiInput-formControl': {
      marginTop: 0,
    },

    '& .MuiInputBase-input': {
      padding: '0px 0 2px',
    },

    '& .MuiInputBase-root': {
      fontSize: '13px',
      color: theme.palette.type === 'dark' ? monochrome.lightest : monochrome.darker,
    },

    '& .MuiInput-underline:before': {
      borderColor: '#A0A3BD',
    },

    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderColor: '#A0A3BD',
    },
  },
  deleteButton: {
    cursor: 'pointer',
  },
}));
